module.exports = __webpack_public_path__ + "static/media/why-soc-md-mk-stat-1.5dc801f7.png";